(function () {
  'use strict';

  var MODAL_ACTIVE_CLASS = 'prd-rec__modal--active';
  var MONEY_FORMAT =
    (window.theme && (window.theme.moneyFormat || window.theme.money_format)) ||
    (window.Shopify && window.Shopify.money_format) ||
    '${{amount}}';
  var STRIP_ELEMENT = document.createElement('div');

  function formatMoney(cents) {
    var value = typeof cents === 'string' ? parseInt(cents, 10) : cents;
    if (isNaN(value)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, MONEY_FORMAT);
    }

    var match = MONEY_FORMAT.match(/{{\s*(\w+)\s*}}/);
    var placeholder = match && match[1] ? match[1] : 'amount';
    var amount;
    switch (placeholder) {
      case 'amount_no_decimals':
        amount = (value / 100).toFixed(0);
        break;
      case 'amount_with_comma_separator':
        amount = (value / 100).toFixed(2).replace('.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = (value / 100).toFixed(0).replace('.', ',');
        break;
      default:
        amount = (value / 100).toFixed(2);
        break;
    }

    if (!match) {
      return amount;
    }

    return MONEY_FORMAT.replace(match[0], amount);
  }

  function stripHtml(html) {
    if (!html) return '';
    STRIP_ELEMENT.innerHTML = html;
    return STRIP_ELEMENT.textContent.trim();
  }

  function normalizeProductData(rawData) {
    if (!rawData) return null;
    var product = rawData.product || rawData;
    if (!product || !product.id) return null;

    var normalized = {
      id: product.id,
      title: product.title || '',
      url:
        product.url ||
        product.online_store_url ||
        (product.handle ? '/products/' + product.handle : ''),
      image:
        rawData.featured_image_url ||
        (product.featured_image && product.featured_image.src) ||
        '',
      image_alt:
        rawData.featured_image_alt ||
        (product.featured_image && product.featured_image.alt) ||
        product.title ||
        '',
      description:
        rawData.description_plain ||
        stripHtml(product.body_html || product.description || ''),
      options: normalizeOptions(
        rawData.options_with_values ||
          product.options_with_values ||
          product.options ||
          []
      ),
      show_subscribe_toggle: !!rawData.show_subscribe_toggle
    };

    normalized.variants = (product.variants || [])
      .map(function (variant) {
        return buildVariantData(variant, normalized);
      })
      .filter(Boolean);

    return normalized;
  }

  function buildVariantData(variant, product) {
    if (!variant) return null;
    var optionValues = getVariantOptionValues(variant);
    var imageSrc =
      (variant.featured_image && variant.featured_image.src) || product.image || '';
    var imageAlt =
      (variant.featured_image && variant.featured_image.alt) ||
      product.image_alt ||
      product.title ||
      '';

    var allocation =
      variant.selling_plan_allocations && variant.selling_plan_allocations.length
        ? variant.selling_plan_allocations[0]
        : null;
    var subscriptionPrice = allocation ? allocation.price : null;
    var sellingPlanId =
      allocation &&
      (allocation.selling_plan_id ||
        (allocation.selling_plan && allocation.selling_plan.id));

    return {
      id: variant.id,
      title: variant.title,
      option_values: optionValues,
      available: variant.available,
      price: variant.price,
      price_formatted: formatMoney(variant.price),
      compare_at_price: variant.compare_at_price,
      compare_at_price_formatted: variant.compare_at_price
        ? formatMoney(variant.compare_at_price)
        : null,
      subscription_price: subscriptionPrice,
      subscription_price_formatted: subscriptionPrice ? formatMoney(subscriptionPrice) : null,
      selling_plan_id: sellingPlanId || null,
      image: imageSrc,
      image_alt: imageAlt
    };
  }

  function normalizeOptions(options) {
    if (!options || !options.length) return [];

    return options.map(function (option) {
      if (typeof option === 'string') {
        return {
          name: option,
          values: []
        };
      }

      return {
        name: option.name || '',
        values: option.values || []
      };
    });
  }

  function getVariantOptionValues(variant) {
    if (!variant) return [];
    if (variant.options && variant.options.length) {
      return variant.options;
    }

    var values = [];
    if (variant.option1) values.push(variant.option1);
    if (variant.option2) values.push(variant.option2);
    if (variant.option3) values.push(variant.option3);
    return values;
  }

  function initProductRecommendationsSection(sectionEl) {
    if (!sectionEl) return;

    var sectionId = sectionEl.getAttribute('data-section-id');
    var productId = sectionEl.getAttribute('data-product-id');
    var limit = sectionEl.getAttribute('data-limit') || 4;

    if (!productId || !sectionId) return;

    var innerSelector = '[data-product-recommendations-inner]';
    var innerEl = sectionEl.querySelector(innerSelector);

    // If recommendations were rendered server-side already,
    // just init Swiper, price priming, subscription toggles, and AJAX ATC handlers.
    if (innerEl && sectionEl.querySelector('.prd-rec__card')) {
      primePriceData(sectionEl);
      storeProductData(sectionEl);
      initSwiperForSection(sectionEl);
      initQuickBuyForSection(sectionEl);
      attachSubscriptionToggleListeners(sectionEl);
      attachAtcAjaxHandlers(sectionEl);
      return;
    }

    const url = sectionEl.dataset.url;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var updatedInner = doc.querySelector(innerSelector);

        if (!updatedInner || !innerEl) return;

        innerEl.innerHTML = updatedInner.innerHTML;

        // After injecting, initialize everything.
        primePriceData(sectionEl);
        storeProductData(sectionEl);
        initSwiperForSection(sectionEl);
        initQuickBuyForSection(sectionEl);
        attachSubscriptionToggleListeners(sectionEl);
        attachAtcAjaxHandlers(sectionEl);
      })
      .catch(function (error) {
        console.error('Product recommendations error:', error);
      });
  }

  function initSwiperForSection(sectionEl) {
    var useCarousel = sectionEl.getAttribute('data-use-carousel') === 'true';
    if (!useCarousel || typeof Swiper === 'undefined') return;

    var swiperEl = sectionEl.querySelector('.prd-rec__swiper');
    if (!swiperEl) return;

    var showNav = sectionEl.getAttribute('data-show-nav') === 'true';
    var showPagination = sectionEl.getAttribute('data-show-pagination') === 'true';
    var colsMobile = parseInt(sectionEl.getAttribute('data-cols-mobile') || '1', 10);
    var colsDesktop = parseInt(sectionEl.getAttribute('data-cols-desktop') || '3', 10);

    var navNext = sectionEl.querySelector('.prd-rec__nav-button--next');
    var navPrev = sectionEl.querySelector('.prd-rec__nav-button--prev');
    var paginationEl = sectionEl.querySelector('.prd-rec__pagination');

    var swiperConfig = {
      slidesPerView: Math.max(colsMobile, 1),
      spaceBetween: 16,
      keyboard: {
        enabled: true
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous recommended product',
        nextSlideMessage: 'Next recommended product'
      },
      breakpoints: {
        768: {
          slidesPerView: Math.max(colsDesktop, 1),
          spaceBetween: 20
        }
      }
    };

    if (showNav && navNext && navPrev) {
      swiperConfig.navigation = {
        nextEl: navNext,
        prevEl: navPrev
      };
    }

    if (showPagination && paginationEl) {
      swiperConfig.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    // eslint-disable-next-line no-undef
    new Swiper(swiperEl, swiperConfig);
  }

  function storeProductData(sectionEl) {
    if (!sectionEl) return;

    var dataScripts = sectionEl.querySelectorAll('.prd-rec__product-data');
    if (!dataScripts.length) return;

    if (!sectionEl.__prdRecProductStore) {
      sectionEl.__prdRecProductStore = {};
    }

    dataScripts.forEach(function (scriptEl) {
      if (!scriptEl || !scriptEl.textContent || scriptEl.dataset.processed === 'true') {
        return;
      }

      try {
        var productData = JSON.parse(scriptEl.textContent);
        var normalized = normalizeProductData(productData);
        if (normalized && normalized.id) {
          sectionEl.__prdRecProductStore[String(normalized.id)] = normalized;
          scriptEl.dataset.processed = 'true';
        }
      } catch (error) {
        console.warn('Product recommendations: invalid product data', error);
      }
    });
  }

  function initQuickBuyForSection(sectionEl) {
    if (!sectionEl) return;

    var modal = sectionEl.querySelector('[data-prd-rec-modal]');
    if (!modal) return;

    if (!modal.__initialized) {
      setupQuickBuyModal(modal, sectionEl);
      modal.__initialized = true;
    }

    var triggers = sectionEl.querySelectorAll('[data-prd-rec-quick-buy-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger.dataset.quickBuyBound === 'true') return;

      trigger.addEventListener('click', function () {
        var productId = trigger.getAttribute('data-product-id');
        var cardEl = trigger.closest('.prd-rec__card');
        openQuickBuyModal(sectionEl, modal, productId, cardEl);
      });

      trigger.dataset.quickBuyBound = 'true';
    });
  }

  function setupQuickBuyModal(modal, sectionEl) {
    if (!modal) return;

    modal.__state = {
      section: sectionEl,
      product: null,
      selectedVariant: null,
      selectedOptions: []
    };

    var closeEls = modal.querySelectorAll('[data-prd-rec-modal-close]');
    closeEls.forEach(function (closeEl) {
      closeEl.addEventListener('click', function () {
        closeQuickBuyModal(modal);
      });
    });

    var subscribeToggle = modal.querySelector('[data-prd-rec-modal-subscribe]');
    if (subscribeToggle) {
      subscribeToggle.addEventListener('change', function () {
        setPlanSelection(modal, subscribeToggle.checked ? 'subscribe' : 'onetime');
        updateModalPrice(modal);
      });
    }

    initModalPlanPicker(modal);

    var escHandler = function (event) {
      if (event.key !== 'Escape') return;
      if (modal.classList.contains(MODAL_ACTIVE_CLASS)) {
        closeQuickBuyModal(modal);
      }
    };
    modal.__escHandler = escHandler;
    document.addEventListener('keydown', escHandler);
  }

  function initModalPlanPicker(modal) {
    if (!modal) return;
    var planInputs = modal.querySelectorAll('[data-prd-rec-modal-plan-option]');
    if (!planInputs.length) return;

    planInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        handlePlanOptionChange(modal, input.value);
      });
    });
  }

  function handlePlanOptionChange(modal, value) {
    var subscribeToggle = modal.querySelector('[data-prd-rec-modal-subscribe]');
    if (subscribeToggle) {
      subscribeToggle.checked = value === 'subscribe';
    }
    setPlanSelection(modal, value);
    updateModalPrice(modal);
  }

  function setPlanSelection(modal, planValue) {
    if (!modal) return;
    var planCards = modal.querySelectorAll('.prd-rec__modal-plan');
    if (!planCards.length) return;

    planCards.forEach(function (card) {
      var input = card.querySelector('[data-prd-rec-modal-plan-option]');
      if (!input || input.disabled) {
        card.classList.remove('is-selected');
        return;
      }

      if (input.value === planValue) {
        input.checked = true;
        card.classList.add('is-selected');
      } else {
        input.checked = false;
        card.classList.remove('is-selected');
      }
    });
  }

  function toggleSubscribePlanCard(modal, enabled) {
    if (!modal) return;
    var subscribeCard = modal.querySelector('[data-prd-rec-plan-card="subscribe"]');
    if (!subscribeCard) return;

    var subscribeInput = subscribeCard.querySelector('[data-prd-rec-modal-plan-option]');
    if (enabled) {
      subscribeCard.classList.remove('is-hidden');
      if (subscribeInput) subscribeInput.disabled = false;
    } else {
      subscribeCard.classList.add('is-hidden');
      if (subscribeInput) subscribeInput.disabled = true;
    }
  }

  function openQuickBuyModal(sectionEl, modal, productId, cardEl) {
    if (!modal || !sectionEl || !productId) return;

    var store = sectionEl.__prdRecProductStore || {};
    var productData = store[String(productId)];

    if (!productData) {
      productData = extractProductDataFromCard(cardEl);
      if (productData && productData.id) {
        if (!sectionEl.__prdRecProductStore) {
          sectionEl.__prdRecProductStore = {};
        }
        sectionEl.__prdRecProductStore[String(productData.id)] = productData;
      }
    }

    if (!productData) return;

    var state = modal.__state || {};
    state.product = productData;
    state.selectedVariant = null;
    state.selectedOptions = [];
    modal.__state = state;

    var titleEl = modal.querySelector('[data-prd-rec-modal-title]');
    if (titleEl) {
      titleEl.textContent = productData.title || '';
    }

    var subscribeToggle = modal.querySelector('[data-prd-rec-modal-subscribe]');
    if (subscribeToggle) {
      subscribeToggle.checked = true;
    }

    var descriptionEl = modal.querySelector('[data-prd-rec-modal-description]');
    if (descriptionEl) {
      var descriptionEnabled = descriptionEl.getAttribute('data-prd-rec-modal-description-enabled') === 'true';
      if (productData.description) {
        descriptionEl.textContent = productData.description;
        descriptionEl.style.display = descriptionEnabled ? '' : 'none';
        descriptionEl.classList.toggle('is-hidden', !descriptionEnabled);
      } else {
        descriptionEl.textContent = '';
        descriptionEl.style.display = 'none';
        descriptionEl.classList.add('is-hidden');
      }
    }

    renderModalOptions(modal, productData);

    var initialVariant = getInitialVariant(productData);
    if (initialVariant) {
      state.selectedVariant = initialVariant;
      if (initialVariant.option_values) {
        state.selectedOptions = initialVariant.option_values.slice();
      }
    } else if (productData.options && productData.options.length) {
      state.selectedOptions = productData.options.map(function (option) {
        return option.values && option.values.length ? option.values[0] : null;
      });
    }

    updateModalSelectedVariant(modal, initialVariant || null);
    syncModalOptionSelection(modal);

    modal.classList.add(MODAL_ACTIVE_CLASS);
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('prd-rec-modal-open');
  }

  function extractProductDataFromCard(cardEl) {
    if (!cardEl) return null;
    var scriptEl = cardEl.querySelector('.prd-rec__product-data');
    if (!scriptEl || !scriptEl.textContent) return null;

    try {
      var parsed = JSON.parse(scriptEl.textContent);
      return normalizeProductData(parsed);
    } catch (error) {
      console.warn('Product recommendations: unable to parse product data from card', error);
    }

    return null;
  }

  function closeQuickBuyModal(modal) {
    if (!modal) return;

    modal.classList.remove(MODAL_ACTIVE_CLASS);
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('prd-rec-modal-open');

    var form = modal.querySelector('[data-prd-rec-modal-form]');
    if (form) {
      form.reset();
      form.removeAttribute('data-subscription-selling-plan-id');
    }

    if (modal.__state) {
      modal.__state.product = null;
      modal.__state.selectedVariant = null;
      modal.__state.selectedOptions = [];
    }
  }

  function renderModalOptions(modal, productData) {
    if (!modal) return;
    var container = modal.querySelector('[data-prd-rec-modal-options]');
    if (!container) return;

    container.innerHTML = '';
    if (!productData || !productData.options || !productData.options.length) {
      return;
    }

    productData.options.forEach(function (option, index) {
      var optionWrapper = document.createElement('div');
      optionWrapper.className = 'prd-rec__modal-option';

      var label = document.createElement('p');
      label.className = 'prd-rec__modal-option-label';
      label.textContent = option.name || '';
      optionWrapper.appendChild(label);

      var valuesWrapper = document.createElement('div');
      valuesWrapper.className = 'prd-rec__modal-option-values';

      (option.values || []).forEach(function (value) {
        var swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'prd-rec__modal-swatch';
        swatch.textContent = value;
        swatch.setAttribute('data-option-index', index);
        swatch.setAttribute('data-option-value', value);
        swatch.addEventListener('click', function () {
          handleModalOptionSelection(modal, index, value);
        });

        valuesWrapper.appendChild(swatch);
      });

      optionWrapper.appendChild(valuesWrapper);
      container.appendChild(optionWrapper);
    });
  }

  function handleModalOptionSelection(modal, optionIndex, value) {
    if (!modal) return;
    var state = modal.__state;
    if (!state || !state.product) return;

    state.selectedOptions = state.selectedOptions || [];
    state.selectedOptions[optionIndex] = value;

    var matchingVariant = findVariantByOptions(state.product, state.selectedOptions);
    if (!matchingVariant) {
      if (state.selectedVariant && state.selectedVariant.option_values) {
        state.selectedOptions[optionIndex] = state.selectedVariant.option_values[optionIndex];
      }
      return;
    }

    updateModalSelectedVariant(modal, matchingVariant);
    syncModalOptionSelection(modal);
  }

  function syncModalOptionSelection(modal) {
    if (!modal) return;
    var state = modal.__state;
    if (!state || !state.selectedOptions) return;

    var buttons = modal.querySelectorAll('.prd-rec__modal-swatch');
    buttons.forEach(function (button) {
      var index = parseInt(button.getAttribute('data-option-index') || '0', 10);
      var value = button.getAttribute('data-option-value');
      if (state.selectedOptions[index] === value) {
        button.classList.add('is-selected');
      } else {
        button.classList.remove('is-selected');
      }
    });
  }

  function findVariantByOptions(productData, selectedOptions) {
    if (!productData || !productData.variants || !selectedOptions) return null;
    for (var i = 0; i < productData.variants.length; i += 1) {
      var variant = productData.variants[i];
      var matches = true;
      for (var optionIndex = 0; optionIndex < selectedOptions.length; optionIndex += 1) {
        if (variant.option_values[optionIndex] !== selectedOptions[optionIndex]) {
          matches = false;
          break;
        }
      }
      if (matches) {
        return variant;
      }
    }
    return null;
  }

  function getInitialVariant(productData) {
    if (!productData || !productData.variants || !productData.variants.length) {
      return null;
    }

    var availableVariant = productData.variants.find(function (variant) {
      return variant.available;
    });

    return availableVariant || productData.variants[0];
  }

  function updateModalSelectedVariant(modal, variant) {
    if (!modal) return;
    var state = modal.__state || {};
    state.selectedVariant = variant || null;
    if (variant && variant.option_values) {
      state.selectedOptions = variant.option_values.slice();
    }
    modal.__state = state;

    updateModalMedia(modal, variant);
    updateModalForm(modal, variant);
    updateModalSubscribeUI(modal, variant);
    updateModalPrice(modal);
  }

  function updateModalMedia(modal, variant) {
    if (!modal) return;
    var state = modal.__state || {};
    var product = state.product || {};

    var imageEl = modal.querySelector('[data-prd-rec-modal-image]');
    if (!imageEl) return;

    var src = (variant && variant.image) || product.image || '';
    var alt = (variant && variant.image_alt) || product.image_alt || product.title || '';

    if (src) {
      imageEl.src = src;
    } else {
      imageEl.removeAttribute('src');
    }
    imageEl.alt = alt || '';
  }

  function updateModalForm(modal, variant) {
    var form = modal.querySelector('[data-prd-rec-modal-form]');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = variant ? variant.id : '';
    }

    var submitButton = modal.querySelector('[data-prd-rec-modal-submit]');
    if (submitButton) {
      var defaultLabel = submitButton.getAttribute('data-label-default') || 'Add to cart';
      var soldOutLabel = submitButton.getAttribute('data-label-sold-out') || 'Sold out';
      if (!variant || !variant.available) {
        submitButton.disabled = true;
        submitButton.textContent = soldOutLabel;
      } else {
        submitButton.disabled = false;
        submitButton.textContent = defaultLabel;
      }
    }
  }

  function updateModalSubscribeUI(modal, variant) {
    var state = modal.__state || {};
    var product = state.product || {};
    var wrapper = modal.querySelector('[data-prd-rec-modal-subscribe-wrapper]');
    var toggle = modal.querySelector('[data-prd-rec-modal-subscribe]');
    var form = modal.querySelector('[data-prd-rec-modal-form]');

    if (!wrapper || !toggle || !form) return;

    var hasSubscription =
      !!(
        product.show_subscribe_toggle &&
        variant &&
        variant.selling_plan_id &&
        variant.subscription_price
      );

    wrapper.hidden = !hasSubscription;
    toggleSubscribePlanCard(modal, hasSubscription);

    if (!hasSubscription) {
      toggle.checked = false;
      form.removeAttribute('data-subscription-selling-plan-id');
      setPlanSelection(modal, 'onetime');
    } else {
      form.setAttribute('data-subscription-selling-plan-id', variant.selling_plan_id);
      setPlanSelection(modal, toggle.checked ? 'subscribe' : 'onetime');
    }
  }

  function updateModalPrice(modal) {
    if (!modal) return;
    var state = modal.__state || {};
    var variant = state.selectedVariant;
    var priceEl = modal.querySelector('[data-prd-rec-modal-price]');
    if (!priceEl || !variant) {
      if (priceEl) priceEl.innerHTML = '';
      return;
    }

    var subscribeWrapper = modal.querySelector('[data-prd-rec-modal-subscribe-wrapper]');
    var subscribeToggle = modal.querySelector('[data-prd-rec-modal-subscribe]');
    var hasSubscribe =
      subscribeWrapper && subscribeToggle && !subscribeWrapper.hidden && subscribeToggle.checked;

    var regularFormatted = variant.price_formatted || '';
    var subscriptionFormatted = variant.subscription_price_formatted || '';
    if (subscriptionFormatted === 'null') {
      subscriptionFormatted = '';
    }

    var discountPercent = 0;

    var html = '';
    if (
      hasSubscribe &&
      subscriptionFormatted &&
      subscriptionFormatted !== 'null'
    ) {
      var savingsHtml = '';
      if (
        variant.price &&
        variant.subscription_price &&
        variant.price > variant.subscription_price
      ) {
        discountPercent = Math.round(
          (1 - variant.subscription_price / variant.price) * 100
        );
        if (discountPercent > 0) {
          savingsHtml =
            '<span class="prd-rec__price-savings">Save ' + discountPercent + '%</span>';
        }
      }

      html =
        '<span class="prd-rec__price-current prd-rec__price-current--subscribe">' +
        subscriptionFormatted +
        '</span>' +
        '<span class="prd-rec__price-compare">' +
        regularFormatted +
        '</span>' +
        savingsHtml;
    } else {
      html = '<span class="prd-rec__price-current">' + regularFormatted + '</span>';
      if (variant.compare_at_price_formatted) {
        html +=
          '<span class="prd-rec__price-compare">' +
          variant.compare_at_price_formatted +
          '</span>';
      }
    }

    priceEl.innerHTML = html;
    updateModalPlanNotes(modal, regularFormatted, subscriptionFormatted, discountPercent);
  }

  function updateModalPlanNotes(
    modal,
    regularFormatted,
    subscriptionFormatted,
    discountPercent
  ) {
    if (!modal) return;
    var onetimeNote = modal.querySelector('[data-prd-rec-plan-onetime-note]');
    if (onetimeNote) {
      onetimeNote.textContent = regularFormatted || '';
    }

    var subscribeNote = modal.querySelector('[data-prd-rec-plan-subscribe-note]');
    if (subscribeNote) {
      if (subscriptionFormatted) {
        var compareHtml = regularFormatted
          ? '<span class="prd-rec__modal-plan-price-compare">' + regularFormatted + '</span>'
          : '';
        subscribeNote.innerHTML =
          '<span class="prd-rec__modal-plan-note-price">' +
          '<span class="prd-rec__modal-plan-price-current">' +
          subscriptionFormatted +
          '</span>' +
          compareHtml +
          '</span>';
      } else {
        subscribeNote.textContent = '';
      }
    }

    var badge = modal.querySelector('[data-prd-rec-plan-subscribe-badge]');
    if (badge) {
      if (discountPercent > 0) {
        badge.textContent = 'Save ' + discountPercent + '%';
        badge.classList.add('is-visible');
      } else {
        badge.textContent = '';
        badge.classList.remove('is-visible');
      }
    }
  }

  /**
   * Normalize / prime price elements:
   * - Ensure data-regular-price-formatted is set (fallback to current text).
   * - Store original HTML for safe fallback when toggling.
   */
  function primePriceData(sectionEl) {
    var priceEls = sectionEl.querySelectorAll('.prd-rec__price');
    if (!priceEls.length) return;

    priceEls.forEach(function (priceEl) {
      var regularFormatted = priceEl.getAttribute('data-regular-price-formatted');

      // If missing or literally "undefined"/"null", derive from text.
      if (
        !regularFormatted ||
        regularFormatted === 'undefined' ||
        regularFormatted === 'null'
      ) {
        var text = (priceEl.textContent || '').trim();
        if (text) {
          regularFormatted = text;
          priceEl.setAttribute('data-regular-price-formatted', regularFormatted);
        }
      }

      // Store original HTML once so we can always revert if needed.
      if (!priceEl.getAttribute('data-original-price-html')) {
        priceEl.setAttribute('data-original-price-html', priceEl.innerHTML);
      }
    });
  }

  /**
   * Attach change listeners to Subscribe & Save toggles
   * so that we can swap prices when toggled.
   */
  function attachSubscriptionToggleListeners(sectionEl) {
    if (!sectionEl) return;

    var toggles = sectionEl.querySelectorAll('.prd-rec__subscribe-input');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      // Set initial state
      updateCardPriceFromToggle(toggle);

      toggle.addEventListener('change', function (event) {
        updateCardPriceFromToggle(event.target);
      });
    });
  }

  /**
   * Attach AJAX add-to-cart behavior to recommendation forms.
   * Uses Shopify's /cart/add.js endpoint and stays on the same page.
   */
  function attachAtcAjaxHandlers(sectionEl) {
    if (!sectionEl) return;

    var forms = sectionEl.querySelectorAll('.prd-rec__form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        handleAjaxAddToCart(form);
      });
    });
  }

  /**
   * Core AJAX add-to-cart using Shopify's /cart/add.js API.
   */
  function handleAjaxAddToCart(form) {
    if (!form) return;

    var formData = new FormData(form);

    var variantId = formData.get('id');
    if (!variantId) {
      console.warn('No variant id found on recommendation form.');
      return;
    }

    var quantity = parseInt(formData.get('quantity') || '1', 10);
    if (isNaN(quantity) || quantity < 1) {
      quantity = 1;
    }

    // Collect properties (e.g., Subscribe & Save)
    var properties = {};
    formData.forEach(function (value, key) {
      if (key.indexOf('properties[') === 0 && key.slice(-1) === ']') {
        var propName = key.substring('properties['.length, key.length - 1);
        properties[propName] = value;
      }
    });

    // Determine if toggle is checked for subscription
    var toggle = form.querySelector('.prd-rec__subscribe-input');
    var isSubscribed = !!(toggle && toggle.checked);
    var sellingPlanId = form.getAttribute('data-subscription-selling-plan-id');

    var item = {
      id: variantId,
      quantity: quantity
    };

    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    // Only send selling_plan if toggle checked and id is present
    if (isSubscribed && sellingPlanId) {
      item.selling_plan = sellingPlanId;
    }

    var payload = {
      items: [item]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw errorData;
          });
        }
        return response.json();
      })
      .then(function (data) {
        var event = new CustomEvent('productRecommendations:itemAdded', {
          detail: data
        });
        document.dispatchEvent(event);
      })
      .catch(function (error) {
        console.error('Error adding recommendation item to cart:', error);
      });
  }

  /**
   * Given a toggle input, find its card and update price UI
   * depending on checked state.
   */
  function updateCardPriceFromToggle(toggle) {
    var cardEl = toggle.closest('.prd-rec__card');
    if (!cardEl) return;

    var isSubscribed = toggle.checked;
    updateCardPrice(cardEl, isSubscribed);
  }

  /**
   * Core price swap logic.
   * When isSubscribed = true and a subscription price is present,
   * show discounted price + crossed-out original.
   */
  function updateCardPrice(cardEl, isSubscribed) {
    var priceEl = cardEl.querySelector('.prd-rec__price');
    if (!priceEl) return;

    var regularFormatted = priceEl.getAttribute('data-regular-price-formatted');
    var subscriptionFormatted = priceEl.getAttribute(
      'data-subscription-price-formatted'
    );
    var originalHtml = priceEl.getAttribute('data-original-price-html');

    // Guard against bad/missing data attributes
    if (
      !regularFormatted ||
      regularFormatted === 'undefined' ||
      regularFormatted === 'null'
    ) {
      if (originalHtml) {
        // If we really don't know what to do, just restore original markup.
        priceEl.innerHTML = originalHtml;
      }
      return;
    }
    // If subscribed and subscription price exists, show both
    if (isSubscribed) {
      priceEl.innerHTML =
        '<span class="prd-rec__price-current prd-rec__price-current--subscribe">' +
        subscriptionFormatted +
        '</span>' +
        '<span class="prd-rec__price-compare">' +
        regularFormatted +
        '</span>';
    } else {
      // Fallback: regular price only
      priceEl.innerHTML =
        '<span class="prd-rec__price-current">' + regularFormatted + '</span>';
    }
  }

  function initAllProductRecommendations() {
    var sections = document.querySelectorAll(
      '[data-section-type="product-recommendations"]'
    );
    if (!sections.length) return;

    sections.forEach(function (sectionEl) {
      initProductRecommendationsSection(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductRecommendations);
  } else {
    initAllProductRecommendations();
  }
})();
